<template>
  <div>
    <wc-page-title :title='title' :loading='isPageLoading || isDeleting' fullWidth class='ml-2'>
      <template v-slot:appendSubtitle v-if='!!groupsWithUnrouted.length || projectsInNonExistentGroups > 0'>
        <template v-if='!!groupsWithUnrouted.length'>
          <v-icon class='mb-2 ml-2' color='error'>mdi-exclamation-thick</v-icon>
          <span class='error--text'>You have unrouted projects in - {{ groupsWithUnrouted.toString() }}</span>
        </template>
        <template v-if='!isPageLoading && projectsInNonExistentGroups > 0'>
          <v-icon class='mb-2 ml-6' color='error'>mdi-alert</v-icon>
          <span class='error--text'>{{ "You have " + projectsInNonExistentGroups + " undisplayed projects in " +
            nonExistentGroups.toString() + " (groups that haven't been created yet)" }}</span>
        </template>
        <template v-if='!isPageLoading && title == "Lawn" && lawnCareProjectsWithNoFrequency > 0'>
          <v-icon class='mb-2 ml-6 mr-1' color='error'>mdi-help-circle-outline</v-icon>
          <span class='error--text'>
            {{ "You have " + lawnCareProjectsWithNoFrequency + " lawncare projects with no frequency set" }}
          </span>
        </template>
      </template>
    </wc-page-title>

    <div class='main-wrapper'>
      <unrouted v-show='showUnrouted' class='ml-6' :unrouted='unrouted' :isLoading='isLoading' :isPageLoading='isPageLoading'
        :filterLawnCare='filterLawnCare' @deselect='deselect' @select='select' @move='move'
        @openQuickView='openQuickView' @getLatLng='getLatLng'></unrouted>
      <div class='main-container'>
        <div style='display:flex; align-items:flex-start;'>
          <route-groups-button-bar ref='buttonbar' class='ml-4 mt-4' style='flex:1;' :selected='selected' :showMap='showMap'
          :disableClearMarkers='disableClearMarkers' :division='division' :animateHelp='animateHelp'
          :setupHelp='setupHelp' :filterLawnCare='filterLawnCare' :showAllProjects='showAllProjects'
          :loading='rendering' :showUnrouted='showUnrouted' @deselectAll="deselectAll" @toggleMap='toggleMap'
          @addGroup='editGroup' @clearMarkers='clearMarkers' @helpClicked='helpClicked = true'
          @toggleFilterLawnCare='toggleFilterLawnCare' @toggleShowAllProjects='toggleShowAllProjects'
          @toggleUnrouted='showUnrouted = !showUnrouted' @openProgress='showProgressDialog = true'></route-groups-button-bar>
        </div>
        <div class='sub-container'>
          <div class='route-groups-container'>
            <template v-for='group in routeGroups'>
              <route-group class='mr-5' :key='group.id' :group='group' :isLoading='isLoading'
                :areProjectsSelected='areProjectsSelected' :filterLawnCare='filterLawnCare'
                :showAllProjects='showAllProjects' @select='select' @deselect='deselect' @move='move'
                @editGroup='editGroup' @mapGroup='mapGroup' @openCrewVisits='openCrewVisits'
                @openQuickView='openQuickView' @getLatLng='getLatLng'></route-group>
            </template>
          </div>
          <div :class='showMap ? "" : "hidden "' class='map-canvas' id='groups_map_canvas'></div>
        </div>
      </div>
    </div>

    <v-dialog v-model="rendering" persistent width='125'>
      <v-card color="primary" dark class='d-flex'>
        <v-card-subtitle class="body-2 pt-5">
          Please wait
        </v-card-subtitle>
      </v-card>
    </v-dialog>

    <group-details-dialog ref='groupDetailsDialog' :showDialog='showDialog' :isLoading='isLoading'
      :usedLetters='usedLetters' v-model='routeGroupCopy' @update='saveGroup' @cancel='showDialog = false'
      @deleteGroup='deleteGroup'></group-details-dialog>

    <crew-visits-dialog :showDialog='showCrewVisits' @close='showCrewVisits = false'
      :project='projectCV'></crew-visits-dialog>

    <project-quick-view v-if='projectQV' :showDialog='showQuickView' :project='projectQV' @loadNext='nextProject'
      @loadPrev='prevProject' @close='showQuickView = false'></project-quick-view>

    <!-- Progress Bar Dialog -->
    <v-dialog v-model='showProgressDialog' max-width='420'>
      <v-card>
        <v-card-title class='subtitle-1 font-weight-bold pb-2'>
          <v-icon left color='primary'>mdi-chart-line</v-icon>
          Route Progress
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class='pt-3 pb-2'>
          <div style='background:#0D1B2A; color:#fff; border-radius:8px; padding:10px 14px; margin-bottom:12px;'>
            <span class='font-weight-bold' style='font-size:14px;'>All Route Progress</span>
            <span style='font-size:13px;'> &mdash; {{ allRouteCompleted }}/{{ allRouteTotal }}</span>
            <span style='font-size:12px; color:#90CAF9;'> &mdash; {{ allRouteTotal - allRouteCompleted }} route remaining</span>
          </div>
          <v-simple-table dense>
            <tbody>
              <tr v-for='stat in routeGroupStats' :key='stat.name'>
                <td style='width:55%; font-weight:500;'>{{ stat.name }}</td>
                <td style='color:#1565C0; font-weight:600;'>{{ stat.completed }}/{{ stat.total }}</td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color='primary' @click='showProgressDialog = false'>Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import projectsAPI from '@/modules/projects/api/projects';
import GroupDetailsDialog from './GroupDetailsDialog';
import Unrouted from './Unrouted';
import RouteGroup from './RouteGroup';
import ButtonBar from './ButtonBar';
import gmapsInit from '@/utils/gmaps';
import miscServices from '@/services/misc';
import CrewVisitsDialog from '../scheduleDetail/CrewVisitsDialog';
import ProjectQuickView from './ProjectQuickView';
import moment from 'moment';
import _ from 'lodash';
import { isProjectActive } from '@/modules/projects/services/activeProjects';

export default {
  name: 'project-routing-base',
  data: () => ({
    isLoading: false,
    isDeleting: false,
    isMapping: false,
    isPageLoading: true,
    rendering: false,
    showDialog: false,
    showCrewVisits: false,
    filterLawnCare: false,
    projectCopy: {},
    projectCV: {},
    showAllProjects: false,
    showQuickView: false,
    showConfirmGeoDialog: false,
    helpClicked: false,
    projectQV: {},
    showMap: false,
    showUnrouted: true,
    showProgressDialog: false,
    unrouted: [],
    projects: [],
    routeGroups: [],
    routeGroupCopy: {},
    selected: [],
    map: null,
    google: null,
    markers: [],
  }),
  computed: {
    division() {
      return _.find(this.$store.state.misc.divisions, d => d.id == this.$route.params.id)
    },
    title() {
      return this.division.division
    },
    areProjectsSelected() {
      return this.selected.length > 0
    },
    usedLetters() {
      let tmpArray = []
      if (this.routeGroups.length) {
        this.routeGroups.forEach(g => tmpArray.push(g.route_group))
      }
      return tmpArray
    },
    disableClearMarkers() {
      return !this.markers.length
    },
    irrigationDivision() {
      return _.find(this.$store.state.misc.divisions, d => d.division === 'Irrigation')
    },
    lawnDivision() {
      return _.find(this.$store.state.misc.divisions, d => d.division === 'Lawn')
    },
    snowDivision() {
      return _.find(this.$store.state.misc.divisions, d => d.division === 'Snow')
    },
    groupsWithUnrouted() {
      let tmpArray = []
      if (this.routeGroups.length) {
        this.routeGroups.forEach(g => {
          if (g.unrouted.length) {
            tmpArray.push(g.route_group)
          }
        })
      }
      return tmpArray
    },
    projectsInNonExistentGroups() {
      let count = 0
      this.projects.forEach(p => {
        if (p.route_group && !_.find(this.routeGroups, rg => rg.route_group === p.route_group)) {
          count += 1
        }
      })
      return count
    },
    nonExistentGroups() {
      let tmpArray = []
      this.projects.forEach(p => {
        if (p.route_group && !_.find(this.routeGroups, rg => rg.route_group === p.route_group)) {
          if (!_.includes(tmpArray, p.route_group) && !!p.route_group) {
            tmpArray.push(p.route_group)
          }
        }
      })
      return _.orderBy(tmpArray)
    },
    lawnCareProjectsWithNoFrequency() {
      let count = 0
      this.projects.forEach(p => {
        if (p.has_lawn_care && !p.frequency) {
          count += 1
        }
      })
      return count
    },
    animateHelp() {
      if (this.title === "Snow" && moment(this.today).isBefore('2021-09-17') && this.helpClicked === false) {
        return true
      }
      return false
    },
    setupHelp() {
      if (this.title === "Snow" && moment(this.today).isBefore('2021-10-29')) {
        return true
      }
      return false
    },
    today() {
      return moment().format('YYYY-MM-DD').toString()
    },
    routeGroupStats() {
      const hiddenGroupNames = ['Suspended service', 'Not Sold', 'Test area']
      return this.routeGroups
        .filter(g => !hiddenGroupNames.includes(g.description || g.route_group))
        .map(g => {
          const activeProjects = [...(g.projects || []), ...(g.unrouted || [])].filter(p => isProjectActive(p))
          return {
            name: g.description || g.route_group,
            completed: activeProjects.filter(p => p.crew_visit_status === 'Completed').length,
            total: activeProjects.length,
          }
        })
        .filter(s => s.total > 0)
    },
    allRouteCompleted() {
      return this.routeGroupStats.reduce((sum, s) => sum + s.completed, 0)
    },
    allRouteTotal() {
      return this.routeGroupStats.reduce((sum, s) => sum + s.total, 0)
    },
  },
  mounted() {
    this.$store.state.nav.showDrawer = false
    this.selected = []
    this.getData(this.$route.params.id)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.state.nav.showDrawer = true
    next()
  },
  beforeRouteUpdate(to, from, next) {
    this.getData(to.params.id)
    next()
  },
  methods: {
    async getData(divID) {
      this.isPageLoading = true;
      this.projects = [];
      this.unrouted = [];
      this.routeGroups = [];
      this.showAllProjects = false;
      if (divID == this.irrigationDivision.id) {
        this.projects = await projectsAPI.getProjectsForRouteGroups(divID);
      } else if (divID == this.lawnDivision.id) {
        this.projects = await projectsAPI.getProjectsForRouteGroups(divID, true);
      } else {
        this.projects = await projectsAPI.getProjectsForRouteGroups(divID, true)
      }
      let tmp = await projectsAPI.getProjectRouteGroups(divID);
      this.routeGroups = _.orderBy(tmp, 'route_group');
      // reminder to change unrouted to be a computed, since these projects are still in this.projects and referenced via Quantum Entanglment
      // and additional cleanup within the move method (one day when MJ has time)
      this.unrouted = _.filter(this.projects, d => (d.route_group === "" || d.route_group === null))
      await this.loadProjects();
      await this.initMap();
      this.isPageLoading = false;
    },
    nextProject() {
      const route_projects = this.projects.filter(proj => proj.route_group === this.projectQV.route_group);
      for (let i = 0; i < route_projects.length; i++) {
        if (route_projects[i].id === this.projectQV.id) {
          this.projectQV = route_projects[i + 1] ?? route_projects[0];
          break;
        }
      }
    },
    prevProject() {
      const route_projects = this.projects.filter(proj => proj.route_group === this.projectQV.route_group);
      for (let i = 0; i < route_projects.length; i++) {
        if (route_projects[i].id === this.projectQV.id) {
          this.projectQV = route_projects[i - 1] ?? route_projects[this.projects.length - 1];
          break;
        }
      }
    },
    getProjects(group) {
      let tmp = _.filter(this.projects, p => p.route_group === group.route_group)
      // remove un-numbered projects from tmp first - so we can render them at the top to be dealt with
      let unrouted = _.remove(tmp, p => !p.route_number)
      group.unrouted = unrouted
      group.projects = _.orderBy(tmp, ['route_number'])
    },

    loadProjects() {
      this.routeGroups.forEach(rg => this.getProjects(rg))
    },

    async saveGroup() {
      this.isLoading = true
      this.routeGroupCopy.division = this.division.id
      if (this.routeGroupCopy.id) {
        let tmp = await projectsAPI.updateProjectRouteGroup(this.routeGroupCopy)
        this.getProjects(tmp)
        this.routeGroups = miscServices.replaceObject(this.routeGroups, tmp)
      } else {
        let tmp = await projectsAPI.createProjectRouteGroup(this.routeGroupCopy)
        this.getProjects(tmp)
        this.routeGroups.push(tmp)
      }
      this.showDialog = false
      this.isLoading = false
    },

    async editGroup(routeGroup = null) {
      if (routeGroup) {
        this.routeGroupCopy = _.cloneDeep(routeGroup)
      } else {
        this.routeGroupCopy = {}
      }
      this.$refs.groupDetailsDialog.resetValidate()
      this.showDialog = true
    },

    async deleteGroup() {
      this.isDeleting = true
      await projectsAPI.removeProjectRouteGroup(this.routeGroupCopy)
      this.routeGroups = miscServices.removeObject(this.routeGroups, this.routeGroupCopy)
      this.isDeleting = false
      this.showDialog = false
    },

    async move(groupID = null, beforeProjectPK = 0) {
      this.isLoading = true
      let i = this.routeGroups.findIndex(r => r.id === groupID)

      console.log('move called')
      console.log('group: ' + this.routeGroups[i].route_group)
      console.log('before project: ' + beforeProjectPK)

      let groupsByIdThatNeedUpdate = [groupID]

      this.selected.forEach(p => {
        // remove itself from its old array first
        let target
        if (p.route_group) {
          let group = this.routeGroups.find(r => r.route_group === p.route_group)
          groupsByIdThatNeedUpdate.push(group.id)
          if (_.find(group.unrouted, p)) {
            target = group.unrouted
          } else {
            target = group.projects
          }
        } else {
          target = this.unrouted
        }
        let old = _.find(target, o => o.pk === p.pk)
        let index = target.indexOf(old)
        target.splice(index, 1)

        //then modify and add to new array
        p.route_group = this.routeGroups[i].route_group
        p.is_selected = false
      })
      if (beforeProjectPK) {
        console.log('splice in middle')
        let index = this.routeGroups[i].projects.findIndex(p => p.pk === beforeProjectPK)
        this.routeGroups[i].projects.splice(index, 0, ...this.selected)
      } else {
        console.log('add to end')
        this.routeGroups[i].projects.push(...this.selected)
      }

      groupsByIdThatNeedUpdate = _.uniq(groupsByIdThatNeedUpdate)

      let groupUpdateArray = []
      groupsByIdThatNeedUpdate.forEach(r => groupUpdateArray.push(this.getUpdateGroupObject(r)))
      console.log(groupUpdateArray)
      projectsAPI.updateProjectGrouping(groupUpdateArray)

      this.selected = []
      this.isLoading = false
    },

    getUpdateGroupObject(groupID) {
      let updateArray = []
      let group = this.routeGroups.find(r => r.id === groupID)
      group.projects.forEach((w, i) => {
        w.route_number = i + 1
        updateArray.push(w.pk)
      })
      let routeUpdateObject = { 'group': group.route_group, 'projects': updateArray }
      return routeUpdateObject
    },

    select(proj) {
      if (!this.filterLawnCare) {
        let tmpProj = this.projects.find(p => p.pk === proj.pk)
        tmpProj.is_selected = true
        this.selected.push(proj)
      } else {
        // if the filter is on, selection is disabled - so we animate the filter button to alert the user.
        this.$refs.buttonbar.animateFilterLawnCareButton()
      }

    },

    deselect(proj) {
      let tmpProj = this.projects.find(w => w.pk === proj.pk)
      let index = this.selected.indexOf(tmpProj)
      this.selected.splice(index, 1)
      tmpProj.is_selected = false
    },

    deselectAll() {
      let tmp = _.cloneDeep(this.selected)
      tmp.forEach(s => {

        console.log('deselecting - ')
        console.log(s)

        this.deselect(s)
      })
    },

    openCrewVisits(proj) {
      this.projectCV = _.cloneDeep(proj)
      this.showCrewVisits = true
    },

    openQuickView(proj) {
      this.projectQV = _.cloneDeep(proj)
      this.showQuickView = true
    },

    async getLatLng(proj) {
      this.isPageLoading = true
      this.projectCopy = _.cloneDeep(proj)
      await this.getCoordinates()
      this.clearMarkers()
      this.showMap = true
      setTimeout(() => {
        this.dropMarkers([this.projectCopy])
      }, 1000)
      this.isPageLoading = false
    },

    getCoordinates() {
      this.geocoder = new this.google.maps.Geocoder();
      let address = this.projectCopy.site_address + ", " + this.projectCopy.site_city
      this.geocoder.geocode({ 'address': address }, (results, status) => {
        if (status == 'OK') {
          console.log('got results')
          console.log(results)
          this.projectCopy.lat = results[0].geometry.location.lat()
          this.projectCopy.lng = results[0].geometry.location.lng()
          let tmp = {
            id: this.projectCopy.id,
            lat: this.projectCopy.lat,
            lng: this.projectCopy.lng,
          }
          console.log(tmp)
          projectsAPI.updateProject(tmp)
          let thinProj = _.find(this.projects, p => p.id === tmp.id)
          thinProj.lat = tmp.lat
          thinProj.lng = tmp.lng
        } else {
          alert('Geocode was not successful for the following reason: ' + status)
        }
      })
    },

    async initMap() {
      try {
        this.google = await gmapsInit()
        let mapOptions = {
          center: new this.google.maps.LatLng(53.53, -113.5),
          zoom: 10,
          mapTypeId: this.google.maps.MapTypeId.ROADMAP,
          gestureHandling: 'greedy'
        }
        this.map = new this.google.maps.Map(document.getElementById('groups_map_canvas'), mapOptions);
      } catch (error) {
        console.error(error);
      }
    },
    mapGroup(group) {
      this.showMap = true
      if (!this.filterLawnCare) {
        this.dropMarkers(group.projects)
      } else {
        this.dropMarkers(_.filter(group.projects, p => p.has_lawn_care))
      }
    },

    dropMarkers(projects) {
      // this command requires lat and lng both to be set, so currently cannot be used with un-geolocated projects
      this.isMapping = true
      for (let i = 0; i < projects.length; i++) {
        if (projects[i].lat !== 0) {
          window.setTimeout(() => {
            const latLng = new this.google.maps.LatLng(projects[i].lat, projects[i].lng)
            let routeNumber = projects[i].route_number ? projects[i].route_number : '0'
            this.markers.push(
              new this.google.maps.Marker({
                position: latLng,
                // animation: this.google.maps.Animation.DROP,
                label: { text: routeNumber.toString(), color: 'white' },
                title: projects[i].name + ' - ' + projects[i].site_address,
                map: this.map
              }))
          }, i * 50)
        }
      }
      this.isMapping = false
    },

    clearMarkers() {
      for (let i = 0; i < this.markers.length; i++) {
        this.markers[i].setMap(null);
      }
      this.markers = [];
    },

    toggleMap() {
      this.showMap = !this.showMap
    },
    toggleFilterLawnCare() {
      this.deselectAll()
      this.filterLawnCare = !this.filterLawnCare
    },
    toggleShowAllProjects() {
      this.rendering = true
      setTimeout(() => {
        this.showAllProjects = !this.showAllProjects
        this.$nextTick(() => {
          this.rendering = false
        })
      }, 100)
    }
  },
  components: {
    'unrouted': Unrouted,
    'route-group': RouteGroup,
    'route-groups-button-bar': ButtonBar,
    'group-details-dialog': GroupDetailsDialog,
    'crew-visits-dialog': CrewVisitsDialog,
    'project-quick-view': ProjectQuickView
  }
}
</script>

<style>
.main-wrapper {
  display: flex;
}

.route-groups-container {
  border: 1px solid lightgrey;
  display: flex;
  overflow-x: auto;
  overflow-y: auto;
  margin-right: 10px;
  margin-top: 16px !important;
  min-width: 240px !important;
}

.main-container {
  /*border: 1px solid purple;*/
  overflow-x: auto;
  min-width: 240px !important;
  margin-left: 16px !important;
  margin-right: 16px !important;
}

.sub-container {
  /*border: 1px solid red;*/
  height: 686px;
  overflow-x: auto;
  overflow-y: hidden;
  display: flex;
}

.map-canvas {
  border: 1px solid green;
  margin-top: 16px !important;
  min-width: 800px;
  height: 670px;
}

.hidden {
  display: none;
}
</style>
